import React from 'react';
import { Loading, useTranslate } from 'react-admin';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import Create from '../common/views/Create';
import ReviewForm from './ReviewForm';
import useReviewGrid from './useReviewGrid';

const ReviewCreate = (props) => {
    const grid = useReviewGrid();
    const translate = useTranslate();

    if (!grid) {
        return <Loading />;
    }

    // The server refuses it anyway: only the review manager creates reviews for now.
    if (!grid.is_manager) {
        return (
            <Card sx={{ marginTop: '16px' }}>
                <CardContent>
                    <Typography>{translate('Reviews are written by your manager. You will find here the ones shared with you.')}</Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Create {...props} redirect="show">
            <ReviewForm
                grid={grid}
                isCreate
                defaultValues={{ kind: 'manager', scores: {} }}
            />
        </Create>
    );
};

export default ReviewCreate;
